<template>
  <div class="container-fluid">
    <div class="row tick-row" style="min-height: 100vh;">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: 0 auto; text-align: center;display: flex;"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                    </div>
                  </div>
                  <div class="row">
                    <img
                      class="img-responsive"
                      src="/static/assets/images/check.png"
                      alt="ClearMeOut"
                      style="
                        max-width: 80px;
                        margin: 10px auto;
                        margin-top: 100px;
                        display: block;
                      "
                    />
                    <h3 style="text-align: center;text-transform: uppercase;color: #6773dd;">Payment Successfully Completed!</h3>

                    <button type="button" v-on:click="submit" class="btn btn-primary check-btn" style="margin: 0px auto;display: block;border-radius: 10px;background: #6874dd;margin-top: 35px;">
                        Back Home
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "support_track",
  data() {
    return {
      msg: "Clear Me Out - Support",
      email: "",
      ticketNumber: "",
      firstName: "",
      lastName: "",
      emailRequiredError: false,
      ticketNumberRequiredError: false,
      emailError: false,
      fullNameRequiredError: false,
      country: "Sri Lanka",
      orderId: `${Math.random() * 999999}`,
    };
  },
  methods: {
    onSelectCountry: function (d) {
      console.log("onSelectCountry:e", d);
      this.country = d.name;
    },
    submit: function (e) {
      window.location.href = "https://www.clearmeout.com";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/paymentSuccess.vue